/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const snowmobile_medium = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M18.748 12.01h4.158m.344 5.243c0 1.906-1.759 2.247-3.252 2.247m-4.252 0h4.252M11.994 4.508c.965 0 2.185-.16 2.627.942l.975 2.515m-6.228 8.527h.75m-.75 0c0-.199.176-.375.375-.375.2 0 .375.176.375.375m-.75 0c0 .199.176.374.375.374a.386.386 0 0 0 .375-.374m12.788-4.482a11.005 11.005 0 0 0-4.281-5.751c-1.396-.917-2.33.776-3.029 1.706m7.31 4.045c.358 1.124.615 2.993-1.158 2.996h-3m-3.152-7.04c-.54.718-1.07 1.797-2.101 1.797H9.614c-1.588 0-1.952-2.247-3.494-2.247H2.443C1.076 7.51.277 9.13 1.056 10.206c1.533 1.488 3.1 2.937 4.61 4.45m0 0 2.926-1.098c1.464-.548 3.091.152 3.796 1.448m-6.723-.35L1.89 16.073c-1.727.65-1.32 3.424.623 3.427H9.67c2.246.002 3.778-2.546 2.718-4.494m0 0h6.36m0 0 1.25 4.494"
    />
  </svg>
)
export default snowmobile_medium
